// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewForm_container__u0wQV","form":"ReviewForm_form__26AFf","btn":"ReviewForm_btn__2ydFl"};